import React from 'react';
import HeroSection from "../Home/HeroSection/HeroSection";
import OurProduct from "../Home/OurProduct/OurProduct";
import SourceCode from "../Home/SourceCode/SourceCode";
import WhatWeProvide from "../Home/WhatWeProvide/WhatWeProvide";

const HomePage = () => {
	return (
		<>
			<HeroSection />
			<OurProduct />
			<SourceCode />
			<WhatWeProvide />
		</>
	);
};

export default HomePage;